import { AbstractNetworkPrintingAdapter } from './AbstractNetworkPrintingAdapter';
import { VelocityNetworkPrintingAdapter } from './VelocityNetworkPrintingAdapter';
import { CrossFrameNetworkPrintingAdapter } from './CrossFrameNetworkPrintingAdapter';
import { EnvironmentDetail } from '../../../utils/EnvironmentDetailUtils';

/**
 * Factory class that provides the appropriate network printing adapter based on the current environment.
 * Implements singleton pattern to ensure only one adapter instance is created per session.
 */
export class NetworkPrintingAdapterProvider {
    private static instance: AbstractNetworkPrintingAdapter;

    /**
     * Gets the appropriate network printing adapter for the current environment.
     * Uses environment detection to determine whether to return VelocityNetworkPrintingAdapter
     * for Velocity browser environments or CrossFrameNetworkPrintingAdapter for standard environments.
     *
     * @returns The appropriate network printing adapter instance
     */
    public static get(): AbstractNetworkPrintingAdapter {
        if (!NetworkPrintingAdapterProvider.instance) {
            if (EnvironmentDetail.isVelocityBrowser(window)) {
                console.log('NetworkPrinting: Velocity Browser detected, using VelocityNetworkPrintingAdapter');
                NetworkPrintingAdapterProvider.instance = new VelocityNetworkPrintingAdapter();
            } else {
                console.log('NetworkPrinting: Using CrossFrameNetworkPrintingAdapter');
                NetworkPrintingAdapterProvider.instance = new CrossFrameNetworkPrintingAdapter();
            }
        }
        return NetworkPrintingAdapterProvider.instance;
    }
}
